import * as React from 'react';
var defaults = {
  context: {}
};
/**
 * @protected
 */
var BexApiContext = React.createContext(defaults);
/**
 * Provider component for supplying the common BexApi data to your React tree.
 * This data can be read with the `useBexApi()` hook in your function components.
 */
export var BexApiProvider = function (props) {
  var children = props.children,
    context = props.context;
  var value = {
    context: context
  };
  return React.createElement(BexApiContext.Provider, {
    value: value
  }, children || null);
};
BexApiProvider.displayName = 'BexApiProvider';
/**
 * React hook for reading the values in the nearest parent `BexApiProvider` in your tree.
 *
 * @returns {IBexApiFields} an object that you can destructure to access the members you need.
 *
 * @example
 * const MyComponent: React.FunctionComponent<{}> = () => {
 *   const { contextInput } = useBexApi();
 *
 *   const { data } = useQuery<SomeQuery>(query, {
 *     variables: {
 *       contextInput
 *     }
 *   });
 *
 *   .....
 *   ...
 * }
 */
export var useBexApi = function () {
  return React.useContext(BexApiContext);
};